import {
  GoogleReCaptchaProvider,
  withGoogleReCaptcha,
} from 'react-google-recaptcha-v3';

import { SERVER_URL, envVariables } from '@/constants/index';
import { Layout } from '@/components/common';
import { Login } from '@/components/login/Login/Login';
import { findWidget } from '@/utils/findWidget';

import { useAuthentication } from '../../hooks/authHelper';

export default function Page({ data }) {
  useAuthentication();
  const parsedData = JSON.parse(data);
  const applicationItem = findWidget(parsedData.widgets, 'application_banner');

  const LoginWrap = withGoogleReCaptcha(Login);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY_V3}
    >
      <Layout
        navbar={parsedData.menu}
        metadata={parsedData?.metadata}
        breadcrumbs={parsedData?.breadcrumbs}
        appDownload={parsedData?.app_download_widget}
        withoutTheme
      >
        <LoginWrap item={applicationItem} />
      </Layout>
    </GoogleReCaptchaProvider>
  );
}

export const getServerSideProps = async ({ locale }) => {
  const response = await fetch(`${SERVER_URL}/pages/home/`, {
    headers: {
      'Accept-Language': locale,
    },
  });
  const data = await response.text();

  return {
    props: {
      data,
    },
  };
};
